// ============================================================
// The ring's once-set settings, behind `Ring…`
// ============================================================
// Spacing, arc and fill order are set once and then left alone, so they
// open UPWARD over the map - over empty air, rather than pushing the map
// aside (v8.23.0).

import clsx from '../../utils/clsx';
import common from '../../styles/common.module.css';
import styles from '../../styles/Battlefield.module.css';
import NumberInput from '../NumberInput';

/** Auto spacing from the models' size, or a fixed number of metres. */
function SpacingFields({ ring, onRing }) {
  return (
    <>
      <label className={common.label}>
        Spacing
        <select
          className={common.input}
          aria-label="Ring spacing"
          value={ring.spacing === 'auto' ? 'auto' : 'fixed'}
          onChange={(e) => onRing({ spacing: e.target.value === 'auto' ? 'auto' : 1.5 })}
        >
          <option value="auto">Auto (from size)</option>
          <option value="fixed">Fixed</option>
        </select>
      </label>
      {ring.spacing !== 'auto' && (
        <label className={common.label}>
          Metres
          <NumberInput
            className={common.input}
            aria-label="Spacing metres"
            value={ring.spacing}
            min={0.2}
            step={0.1}
            onChange={(v) => onRing({ spacing: v })}
          />
        </label>
      )}
    </>
  );
}

/** How much of the circle the ring fills, and which way a wedge points. */
function ArcFields({ ring, onRing }) {
  return (
    <>
      <label className={common.label}>
        Arc
        <select
          className={common.input}
          aria-label="Ring sweep"
          value={ring.sweep}
          onChange={(e) => onRing({ sweep: Number(e.target.value) })}
        >
          <option value={360}>Full circle</option>
          <option value={180}>Half</option>
          <option value={90}>Wedge</option>
          <option value={45}>Narrow wedge</option>
        </select>
      </label>
      {ring.sweep < 360 && (
        <label className={common.label}>
          Arc from°
          <NumberInput
            className={common.input}
            aria-label="Arc start angle"
            title="Which way the wedge points, in degrees"
            value={ring.startAngle}
            min={0}
            max={359}
            step={15}
            onChange={(v) => onRing({ startAngle: v })}
          />
        </label>
      )}
    </>
  );
}

/**
 * The flyout. The re-ring house rule is read and written through the same
 * permissions document as the GM menu: one source of truth, two places to
 * reach it.
 */
export default function RingFlyout({ ring, onRing, redeployOnMapLoad, onRedeployOnMapLoad }) {
  return (
    <div className={styles.deployFlyout} id="deploy-ring-flyout" data-testid="deploy-ring-flyout">
      <SpacingFields ring={ring} onRing={onRing} />
      <ArcFields ring={ring} onRing={onRing} />
      <label className={common.label}>
        Order
        <select
          className={common.input}
          aria-label="Fill order"
          value={ring.order}
          onChange={(e) => onRing({ order: e.target.value })}
        >
          <option value="roster">Roster order</option>
          <option value="size">Big models outward</option>
        </select>
      </label>
      <label className={clsx(common.label, common.checkRow)}>
        <input type="checkbox" checked={!!redeployOnMapLoad} onChange={(e) => onRedeployOnMapLoad(e.target.checked)} />
        Re-ring on map load
      </label>
    </div>
  );
}
